module.exports = __webpack_public_path__ + "img/vk(white).da738328.svg";